import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	sections: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[32],
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
	},
	sectionHeader: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
	sectionTitle: {
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.lg,
		fontWeight: fontWeights.bold,
		margin: 0,
	},
});
